export const START_LOAD_RESOURCE = 'resourceCache/START_LOAD_RESOURCE';

export const FINISH_LOAD_RESOURCE = 'resourceCache/COMPLETE_LOAD_RESOURCE';

export const SET_RESOURCE = 'resourceCache/SET_RESOURCE';
